<template>
  <div class="between-input-cont">
    <t-input
      placeholder="请输入内容"
      :size="size"
      v-if="dataType === 'number'"
      v-model.number="val1"
      class="width120"
    ></t-input>
    <t-input @input="handleChange" placeholder="请输入内容" :size="size" v-else v-model="val1" class="width120" />
    <span style="width: 20px; text-align: center">-</span>
    <t-input
      placeholder="请输入内容"
      :size="size"
      v-if="dataType === 'number'"
      v-model.number="val2"
      class="width120"
      style="margin-left: 0"
    ></t-input>
    <t-input
      placeholder="请输入内容"
      :size="size"
      v-else
      v-model="val2"
      class="width120"
      @change="handleChange"
      style="margin-left: 0"
    ></t-input>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'mini',
    },
    dataType: {
      type: String,
      default() {
        return 'string';
      },
    },
    value: {},
  },
  data() {
    return {
      val1: '',
      val2: '',
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== undefined) {
        const defaultVal = this.dataType === 'number' ? 0 : '';
        if (Array.isArray(newVal)) {
          this.val1 = newVal[0];
          this.val2 = newVal[1];
        } else if (typeof newVal === 'string') {
          const arr = newVal.split(',');
          this.val1 = arr[0] !== undefined ? arr[0] : defaultVal;
          this.val2 = arr[1] !== undefined ? arr[1] : defaultVal;
        }
      }
    },
    val1() {
      this.updateVal();
    },
    val2() {
      this.updateVal();
    },
  },
  methods: {
    updateVal() {
      this.$emit('input', [this.val1, this.val2]);
    },
    handleChange() {
      this.$emit('onChange', [this.val1, this.val2]);
    },
  },
  created() {
    if (this.value !== undefined) {
      const defaultVal = this.dataType === 'number' ? 0 : '';
      if (Array.isArray(this.value)) {
        this.val1 = this.value[0];
        this.val2 = this.value[1];
      } else if (typeof this.value === 'string') {
        const arr = this.value.split(',');
        this.val1 = arr[0] !== undefined ? arr[0] : defaultVal;
        this.val2 = arr[1] !== undefined ? arr[1] : defaultVal;
      }
    }
  },
};
</script>

<style scoped lang="less">
.between-input-cont {
  display: flex;
  align-items: center;

  .width120 {
    width: 120px;
  }
}
</style>
